module.exports = __webpack_public_path__ + "img/qr-code.40dd26f0.svg";